var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5365 2.28706C14.2431 1.99263 14.2431 1.51526 14.5365 1.22082C14.8299 0.926392 15.3056 0.926392 15.599 1.22082L17.3028 2.93047L17.3127 2.94049C17.8951 3.5293 17.8937 4.48041 17.3087 5.06755L15.6028 6.77929C15.3095 7.07354 14.8341 7.07354 14.541 6.77929C14.2477 6.48505 14.2477 6.00798 14.541 5.71374L15.5013 4.74999H4.24999C3.83578 4.74999 3.5 5.08578 3.5 5.49999V10.75C3.5 11.1642 3.16421 11.5 2.75 11.5C2.33579 11.5 2 11.1642 2 10.75V5.49999C2 4.25735 3.00736 3.24999 4.24999 3.24999H15.4961L14.5365 2.28706Z",
    fill: "#6B6B6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7504 9.25C17.7504 8.83577 17.4146 8.5 17.0004 8.5C16.5862 8.5 16.2504 8.83577 16.2504 9.25V14.5C16.2504 14.9142 15.9146 15.25 15.5004 15.25H4.25241L5.21202 14.2871C5.50544 13.9926 5.50544 13.5152 5.21202 13.2208C4.9186 12.9264 4.44288 12.9264 4.14946 13.2208L2.4457 14.9305L2.43582 14.9405C1.85339 15.5293 1.85473 16.4804 2.43984 17.0675L4.14569 18.7793C4.43892 19.0735 4.91435 19.0735 5.20757 18.7793C5.50081 18.485 5.50081 18.0079 5.20757 17.7137L4.24715 16.75H15.5004C16.743 16.75 17.7504 15.7427 17.7504 14.5V9.25Z",
    fill: "#6B6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchIcon);
export default __webpack_public_path__ + "static/media/switchIcon.57b5b033965318b29ff06c94d0108559.svg";
export { ForwardRef as ReactComponent };